import { SummaryState } from "~vue/RolePlaySummary/constants.ts";

export type SummaryResponse = {
    strengths: string[];
    weaknesses: string[];
    overall_summary: string | null;
    title: string | null;
};

export type SkillPerformanceResponse = {
    name: string | null;
    rationale: string | null;
    how_to_improve: string | null;
    score: number | null;
};

export type BreakdownResponse = {
    skill_scoring: SkillPerformanceResponse[];
};

export type SummaryStates = {
    strengths: SummaryState;
    weaknesses: SummaryState;
    overallSummary: SummaryState;
};

export enum SummaryMessageType {
    PARTIAL = "role_play_summary_partial_addition",
    COMPLETE = "role_play_summary_complete",
}

export enum SummaryDataType {
    SUMMARY = "role_play_summary",
    BREAKDOWN = "role_play_breakdown",
    SKIPPED = "skipped",
}

export type SocketBreakdownData = {
    type: SummaryDataType.BREAKDOWN;
    data: Partial<BreakdownResponse>;
};

export type SocketSummaryData = {
    type: SummaryDataType.SUMMARY;
    data: Partial<SummaryResponse>;
};

export type SocketData = SocketSummaryData | SocketBreakdownData;

export type SummaryPartialMessage = {
    type: SummaryMessageType.PARTIAL;
    data: SocketData;
};

// The complete event carries correlation IDs and the accumulated final summary
// and breakdown. Emitted once, after all PARTIAL chunks have streamed.
export type SummaryCompleteData = {
    role_play_id: number;
    role_play_hashid: string;
    final_summary: Partial<SummaryResponse>;
    final_breakdown: Partial<BreakdownResponse>;
    skipped: boolean;
};

export type SummaryCompleteMessage = {
    type: SummaryMessageType.COMPLETE;
    data: SummaryCompleteData;
};

export type SummaryMessage = SummaryPartialMessage | SummaryCompleteMessage;

export type RolePlayData = Pick<SummaryResponse, "strengths" | "weaknesses"> & {
    overallSummary: SummaryResponse["overall_summary"];
};
